import * as actions from "./actions";

import { act, Actions, createEffect, ofType } from "@ngrx/effects";
import {
    catchError,
    concatMap,
    map,
    mergeMap,
    switchMap,
} from "rxjs/operators";
import { from, of } from "rxjs";
import { combineLatest } from "rxjs";
import { Injectable } from "@angular/core";
import { UDFApiService } from "@services/udf-api.service";
import { Store } from "@ngrx/store";
import { SnowflakeState } from "./state";
import { MatSnackBar } from "@angular/material/snack-bar";

@Injectable()
export class SnowflakeEffects {
    constructor(
        private actions$: Actions,
        private api: UDFApiService,
        private store: Store<SnowflakeState>,
        private snakBar: MatSnackBar,
    ) {}

    getStatistics$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actions.getStatistics),
            mergeMap((action) =>
                this.api.getStatistics().pipe(
                    map((res) => actions.getStatisticsSuccess({ data: res })),
                    catchError((e) => {
                        //console.log("Error:", e)
                        this.snakBar.open(
                            "An error occurred, while loading charts.",
                            "Dismiss",
                            {
                                duration: 5000,
                                verticalPosition: "top",
                                horizontalPosition: "right",
                            },
                        );
                        return of(
                            actions.getStatisticsFailure({ error: e.error }),
                        );
                    }),
                ),
            ),
        );
    });
}
